import {WdiModalAppProps} from '@/components/WdiControls';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import download from '@/utils/download';
import {formatter} from '@/utils/request';
import {FormSp} from '@/services/sales/sp';


const ModifyPaymentAmountModalApp: React.FC<WdiModalAppProps> = (props: WdiModalAppProps) => {
  return (
    <ImportModalApp
      title={props.title}
      visible={props.visible}
      settingsUrl='/expenseapi/spButtons/getModifyAmountSettings'
      uploadingUrl='/expenseapi/spButtons/modifyAmountUploading'
      onClose={props.onClose}
      onSave={props.onSave}
      clientParameters={{
        formId: props.id,
      }}
      importExcels={props?.data?.importExcels}
      events={{
        downloadFormSpDetailForModifyAmount: () => {
          download(FormSp.Buttons.Path.downloadModifyAmountTemplate, formatter({
            method: 'GET',
            body: {formId: props.id},
          }));
        },
      }}
    />
  );
};

export default ModifyPaymentAmountModalApp;
